// extracted by mini-css-extract-plugin
export default {"SectionWrapper":"_SectionWrapper--LjsAM","Headline":"_Headline--Mdy3k","Item":"_Item--DXd1J","Hidden":"_Hidden--ay9ZV","Value":"_Value--KwyHj"};